export const MAJORCLARITY_AUTH_TOKEN_COOKIE = 'majorclarity_auth_token'
export const AUTH0_MAJORCLARITY_COOKIE_NAME = 'auth0_majorclarity'
export const AUTH0_PAPER_COOKIE_NAME = 'auth0_spa_web'
export const PAPER_REFRESH_TOKEN_COOKIE = 'refresh_token'
export const DEFAULT_EXPIRES_IN_SECONDS = 86400
export const MAJORCLARITY_SIGNOUT_PATH = '/majorclarity/signout'
